<div>
  <app-form #searchForm [formName]="searchFormName" [fields]="fields" (changesEvent)="changeSearch($event)" noShowSubmit="true"></app-form>
</div>
